import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import AssemblyOverviewPage from '@/areas/assemblies/Assemblies/AssemblyOverviewPage';
import { canViewAssemblies } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/assemblies/')({
    staticData: { access: { permissions: canViewAssemblies }, chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ filters: 'optional', assemblyId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const assemblyId = Route.useSearch({ select: (search) => search.assemblyId });
    return <AssemblyOverviewPage assemblyId={assemblyId} />;
}
